// src/router/admin/index.ts
import type { RouteRecordRaw } from 'vue-router'
import AdminLayout from '../../layouts/AdminLayout.vue'
import { ROLE_GROUPS } from '../../constants/roleGroups' 
import {adminDashboardRoutes} from './dashboard'
import { adminCommunityRoutes } from './community'
import { adminSettingsRoutes } from './settings'
import { adminSystemsRoutes } from './system'
import { adminPlatformRoutes } from './platform'
import { adminApplicationRoutes } from './apps'
import { adminHelpCenterRoutes } from './helpCenter'
import { adminBoraLearnRoutes } from './boralearn'
import { adminBoraLearnSettingsRoutes } from './boralearn-settings'
import { adminStoreRoutes } from './store'

export const adminRoutes: RouteRecordRaw = {
  path: '/admin',
  component: AdminLayout,
  meta: { requiresAuth: true, requireRoles: ROLE_GROUPS.MANAGE_PANEL },
  children: [
    { path: '', redirect: { name: 'admin.dashboard' } },

    {
      path: 'dashboard',
      name: 'admin.dashboard',
      component: () => import('../../views/admin/AdminDashboardView.vue'),
      meta: {title: 'BORAsuite Admin Dashboard', requiresAuth: true, requireRoles: ROLE_GROUPS.MANAGE_PANEL},
    },

    ...adminPlatformRoutes,
    ...adminApplicationRoutes,
    ...adminCommunityRoutes,
    ...adminSettingsRoutes,
    ...adminSystemsRoutes,
    ...adminDashboardRoutes,
    ...adminHelpCenterRoutes,
    ...adminBoraLearnRoutes,
    ...adminBoraLearnSettingsRoutes,
    ...adminStoreRoutes,
  ],
}
